module.exports = __webpack_public_path__ + "static/other/gamepad.7bb6f45e.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gamepad.json
// module id = 2211
// module chunks = 0